@let currentAxis = this.axis();

<div class="cam-sch" [class.cam-sch--auto]="this.autoHeight()">
  <div class="cam-sch__grid">
    <div class="cam-sch__locked" [style.width.px]="this.lockedWidth()">
      <div class="cam-sch__lockedhead"></div>
      @for (row of this.rows(); track row.key) {
        <div class="cam-sch__lockedrow" [attr.data-resource-id]="row.resourceId" [style.height.px]="row.height">
          @for (cell of row.cells; track cell.key) {
            <div class="cam-sch__cell" [camRenderedContent]="cell.content" [style.width.px]="cell.width"></div>
          }
        </div>
      }
    </div>

    <div class="cam-sch__timeline b-timeline-subgrid" #timeline [style.width.px]="currentAxis.totalWidth">
      <div class="cam-sch__header">
        <div class="cam-sch__headerrow">
          @for (group of this.headerGroups(); track group.key) {
            <div class="cam-sch__headergroup" [style.width.px]="group.width">{{ group.label }}</div>
          }
        </div>
        <div class="cam-sch__headerrow">
          @for (tick of this.headerTicks(); track tick.key) {
            <div class="cam-sch__headertick" [style.width.px]="tick.width">{{ tick.label }}</div>
          }
        </div>
      </div>

      @for (row of this.rows(); track row.key) {
        <div
          class="cam-sch__row"
          [attr.data-resource-id]="row.resourceId"
          [style.--cam-tick-width.px]="currentAxis.tickWidth"
          [style.height.px]="row.height"
        >
          @for (band of row.bands; track band.key) {
            <div
              class="cam-sch__band"
              [style.background-color]="band.color"
              [style.left.px]="band.left"
              [style.width.px]="band.width"
              [title]="band.name"
            ></div>
          }

          @for (bar of row.bars; track bar.key) {
            <div
              class="b-sch-event-wrap"
              [style.height.px]="bar.height"
              [style.left.px]="bar.left"
              [style.top.px]="bar.top"
              [style.width.px]="bar.width"
            >
              <div
                class="b-sch-event"
                [style.--cal-event-color]="bar.color"
                (pointerdown)="this.onBarPointerDown($event, bar, 'move')"
              >
                <div class="b-sch-event-content" [camRenderedContent]="bar.content"></div>
              </div>
              <div class="cam-sch__resize" (pointerdown)="this.onBarPointerDown($event, bar, 'resize')"></div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
